module.exports = __webpack_public_path__ + "static/video01-7c5eb2c54bd61e6646746cfe1e1f9382.jpg";